import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import api, { formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";

export default function ChangePassword() {
  const { user, refreshUser } = useAuth();
  const navigate = useNavigate();
  const [current, setCurrent] = useState("");
  const [next, setNext] = useState("");
  const [confirm, setConfirm] = useState("");
  const [busy, setBusy] = useState(false);

  async function submit(e) {
    e.preventDefault();
    if (next !== confirm) {
      toast.error("New passwords don't match");
      return;
    }
    if (next.length < 8) {
      toast.error("Password must be at least 8 characters");
      return;
    }
    setBusy(true);
    try {
      await api.post("/auth/change-password", { current_password: current, new_password: next });
      toast.success("Password updated");
      await refreshUser?.();
      navigate("/", { replace: true });
    } catch (e) {
      toast.error(formatApiError(e));
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="min-h-screen grid place-items-center p-6 bg-background">
      <div className="max-w-md w-full rounded-3xl border border-border bg-card p-8 shadow-lift">
        <div className="eyebrow">First-time setup</div>
        <h1 className="font-heading text-3xl leading-tight mt-2">Set your password.</h1>
        <p className="text-sm text-muted-foreground mt-2">
          Welcome{user?.name ? `, ${user.name}` : ""}. Choose a strong password to continue —
          minimum 8 characters.
        </p>
        <form onSubmit={submit} className="mt-6 space-y-4" data-testid="change-password-form">
          <div className="space-y-2">
            <Label className="eyebrow">Temp password (from admin)</Label>
            <Input data-testid="cp-current" type="password" value={current} onChange={(e) => setCurrent(e.target.value)} required className="rounded-2xl h-11" />
          </div>
          <div className="space-y-2">
            <Label className="eyebrow">New password</Label>
            <Input data-testid="cp-new" type="password" value={next} onChange={(e) => setNext(e.target.value)} required minLength={8} className="rounded-2xl h-11" />
          </div>
          <div className="space-y-2">
            <Label className="eyebrow">Confirm new password</Label>
            <Input data-testid="cp-confirm" type="password" value={confirm} onChange={(e) => setConfirm(e.target.value)} required minLength={8} className="rounded-2xl h-11" />
          </div>
          <Button data-testid="cp-submit" type="submit" disabled={busy} className="w-full h-12 rounded-full bg-primary text-primary-foreground">
            {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : "Update password"}
          </Button>
        </form>
      </div>
    </div>
  );
}
